//A div with the id 'lz_overlay_preview' only seems to be added when the chat is actually available
var liveZillaUsedIds = ['lz_overlay_chat', 'lz_overlay_wm'];
var idsAddedSoFar = 0;

var observer = new MutationObserver(liveZillaLoaded);
observer.observe($('body')[0], {childList: true});

function liveZillaLoaded(mutations) {
    mutations.forEach(function(mutation) {
        $(mutation.addedNodes).each(function() {
            var addedNode = $(this);
            if (liveZillaUsedIds.indexOf(addedNode.attr('id')) > -1) {
                idsAddedSoFar++;
            }
            if (idsAddedSoFar === liveZillaUsedIds.length) {
                $(document).trigger('liveZillaLoaded');
                observer.disconnect();
            }
        });
    });
}
